import { Component, OnDestroy } from '@angular/core';
import { environment } from '../environments/environment';
import * as mapboxgl from 'mapbox-gl';

@Component({
  selector: 'app-available-leads',
  templateUrl: './available-leads.component.html',
  styleUrl: './available-leads.component.css'
})
export class AvailableLeadsComponent implements OnDestroy {
    map!: mapboxgl.Map;
    mapStyle = 'mapbox://styles/mapbox/light-v10'
    styles = [
      { name: 'Streets', url: 'mapbox://styles/mapbox/streets-v11', icon: 'car',theme: 'fill' },
      { name: 'Satellite', url: 'mapbox://styles/mapbox/satellite-v9', icon: 'global', theme: 'outline' },
      { name: 'Outdoors', url: 'mapbox://styles/mapbox/outdoors-v11', icon: 'picture',theme: 'fill' },
      { name: 'Light', url: 'mapbox://styles/mapbox/light-v10', icon: 'bulb',theme: 'fill' },
      { name: 'Dark', url: 'mapbox://styles/mapbox/dark-v10', icon: 'moon',theme: 'fill' }
    ];
    zoomLevel = 3;

    ngOnInit() {
      this.initMap();
    }

    ngOnDestroy() {
      this.map.remove();
    }

    async initMap() {
      const myLoc: [number, number] = await this.getMyLocation();
      (mapboxgl as any).accessToken = environment.mapbox.accessToken;
      this.map = new mapboxgl.Map({
        container: 'map',
        style: this.mapStyle,
        center: myLoc,
        zoom: this.zoomLevel,
        logoPosition: 'bottom-left',
      });
        this.map.on('load', () => {
        this.addPins(-71.4548, 42.9956, '<h3>Manchester, NH</h3><div><u>Available Leads</u></div><div>Fidium: 2500</div><div>T-Fiber: 1500</div>');
        this.addPins(-106.9562, 44.7972, '<h3>Sheridan, WY</h3><div><u>Available Leads</u></div><div>Fidium: 1000</div><div>T-Fiber: 2000</div>');
      });
    }

    async getMyLocation(): Promise<[number, number]> {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          console.error('Geolocation is not supported by this browser.');
          resolve([-74.5, 40]); // fallback location
          return;
        }
    
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve([position.coords.longitude, position.coords.latitude]);
          },
          (error) => {
            console.error('Browser geolocation error:', error);
            resolve([-74.5, 40]); // fallback location
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        );
      });
    }

    async addPins(lat:any, lng:any, txt:any) {
      const popup = new mapboxgl.Popup({ offset: 25 })
      .setHTML(txt);
      const marker = new mapboxgl.Marker()
      .setLngLat([lat, lng]) 
      .setPopup(popup)
      .addTo(this.map);
    }
}
